import { AxiosInstance } from 'axios';

export class AdminPermissionsService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  isAdmin = async (): Promise<boolean> => {
    try {
      const response = await this.axiosInstance.get(`/account/is-user-admin`);
      return response.data.data;
    } catch (error) {
      console.error('Error checking admin status:', error);
      throw Error('There was an internal error while checking admin status.');
    }
  };
}

export default AdminPermissionsService;
